import React from 'react';
import InformationItem from './InformationItem';
import type { InformationType } from '../../../../types/information';
import type { OptionsType } from '../../../../types/options';

interface InformationListProps {
  informations: InformationType[] | undefined;
  tradingCompany: OptionsType[];
}

const InformationList = ({ informations, tradingCompany }: InformationListProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {informations &&
        informations.map((information, index) => {
          return <InformationItem key={'information-item-' + index} information={information} tradingCompany={tradingCompany} />;
        })}
    </>
  );
};
export default InformationList;
